import React from "react"

export default React.createContext({
  menuFixed: [],
  menuOptions: [],
  addMenuOption: () => null,
  updateMenuOptions: () => null,
  updateMenu: () => null,
})
